import {faChevronDown, faChevronUp} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import React, {useContext, useEffect, useState} from "react";
import {translateService} from "../../services/TranslateService";
import styles from "./SearchFilter.module.scss";
import {cx} from "../MakeReservation/util";
import Coupon from "../MakeReservation/Coupon";
import dataContext, {DataContext} from "../../contexts/dataContext";
import useFilter, {
    Country,
    FilterParameters,
    FuelType,
    Transmission,
    Equipment,
    VehicleType
} from "./Filter";

interface IProps {
    name: string;
    options?: string[];
    selected?: string;
    onChange?: any;
    className?: string;
    style?: any;
    icon?: string;
    reset?: boolean;
}


export default function SearchFilter() {
    const { rootUrl, changeSearchParameters, searchFiltersSelected, sendGaEvent, filteredParams, filteredVehicles,
        acrissCodeFromUrl, changeAcrissCodeFromUrl, modelId, changeModelId } = useContext(DataContext);
    const { handleFilters } = useFilter(); // custom hook for filtering vehicles

  const [filtersVisible, setFiltersVisible] =  useState(searchFiltersSelected);

  // Filter states
  const [selectedFuelType, setSelectedFuelType] = useState<string>('all_fuel');
  const [selectedCountry, setSelectedCountry] = useState<string>( 'all_finland');
  const [selectedVehicleType, setSelectedVehicleType] = useState<string[]>( acrissCodeFromUrl ? [acrissCodeFromUrl] : []); // need to add initial state here based on url params
  const [selectTransmission, setSelectTransmission] = useState<string>( 'all_vehicleType');
  const [selectSeasonTyres, setSelectSeasonTyres] = useState<string[]>( []);
  const [selectedModelId, setSelectedModelId] = useState<number | undefined>(modelId);

  // Radio Button options which builds the filter options for the buttons. Please note to make sure that you have a translation for each option in vehicleSearch
    const fuelOptions = ['all_fuel', 'e95', 'diesel', 'hybrid', 'electric'];
    const countryOptions = ['all_finland', 'scandinavia', 'baltics', 'europe'];
    const vehicleTypeOptions = ['all_vehicleType', 'automatic', 'manual'];

    useEffect(() => {
    // re-render the filter options when it changes
    }, [fuelOptions, countryOptions, vehicleTypeOptions]);

    const ResetFilters = () => {
        setSelectedFuelType('all_fuel');
        setSelectedCountry('all_finland');
        setSelectedVehicleType([]);
        setSelectTransmission('all_vehicleType');
        setSelectSeasonTyres([]);
        setSelectedModelId(undefined);
        sessionStorage.setItem('filterChange', '1');
    }

    useEffect(() => {
        if(filteredParams.reset) {
            ResetFilters();
        }
    },[filteredParams, filteredVehicles]);

    useEffect(() => {
        if (acrissCodeFromUrl) {
            setSelectedVehicleType([acrissCodeFromUrl]);
            changeAcrissCodeFromUrl(undefined);
        }
    }, [acrissCodeFromUrl])

    useEffect(() => {
        if (modelId) {
            setSelectedModelId(modelId);
            changeModelId(undefined);
        }
    }, [modelId, selectedModelId])

    useEffect(() => {
        // when the filter options are selected, it will call the handleFilters function to filter the vehicles
        if(selectedFuelType && selectedCountry && selectedVehicleType && selectTransmission && selectSeasonTyres){
            const filterParameters: FilterParameters = {
                types: selectedVehicleType as VehicleType[],
                fuelType: selectedFuelType as FuelType,
                selectedTag: selectedCountry as Country,
                transmission: selectTransmission as Transmission,
                tyreTypes: selectSeasonTyres as Equipment[],
                model: selectedModelId,
                reset: false
            };
            handleFilters(filterParameters);
        }
    }, [selectedFuelType, selectedCountry, selectedVehicleType, selectTransmission, selectSeasonTyres, acrissCodeFromUrl, selectedModelId, modelId]);

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const name = event.target.name;
        const vehicleType = name.toLowerCase() as VehicleType;
        sessionStorage.setItem('filterChange', '1');
        if (event.target.checked && !selectedVehicleType.includes(vehicleType)) {
            setSelectedVehicleType((prev: string[]) => [...prev, vehicleType]);
        } else {
            setSelectedVehicleType((prev: string[]) => prev.filter(type => type !== vehicleType));
        }
    };

    const handleRemoveModelSearch = () => {
        setSelectedModelId(undefined);
        sessionStorage.setItem('filterChange', '1');

    }
    const handleFuelTypeChange = (event: React.ChangeEvent<{ value: unknown }>) => {
        if (event.target.value) {
            setSelectedFuelType(event.target.value as string)
        }
    }

    const handleCountryChange = (event: React.ChangeEvent<{ value: unknown }>) => {
        if(event.target.value) {
            setSelectedCountry(event.target.value as string);
        }
    }

    const handleTyreChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const vehicleType = event.target.name as Equipment;
        if(vehicleType && event.target.checked) {
            setSelectSeasonTyres((prev: string[]) => [...prev, vehicleType as Equipment]);
        } else {
            setSelectSeasonTyres((prev: string[]) => prev.filter(type => type !== vehicleType));
        }
    }

    const handleTransmissionChange = (event: React.ChangeEvent<{ value: unknown }>) => {
        const transmissionArray = Object.values(vehicleTypeOptions);
        if(transmissionArray.includes(event.target.value as string)) {
            setSelectTransmission(event.target.value as string);
        }
    }

    const CheckBoxTyreButton = ({name,  className, onChange}: IProps) => {
        return (
            <label className={className} htmlFor={name}>
                        <div className={'my-2'}>
                            <input
                                type="checkbox"
                                name={name}
                                defaultChecked={selectSeasonTyres.includes(name)}
                                onChange={onChange}
                            />
                            <span>{translateService.translate(`vehicleSearch.${name}`)}</span>
                        </div>
            </label>
        );
    }

  const CarTypeCheckbox = ({name, style, icon, onChange}: IProps) => {
    return <>
        <label className={cx(styles.carTypeCheckbox, selectedVehicleType?.includes(name) ? styles.orangeBorderAroundPadding5 : styles.grayBorderAroundPadding5)}
            htmlFor={name}>
          <div className={styles.r24SelectCarModelTickBox}>
            <input type="checkbox"
              defaultChecked={selectedVehicleType.includes(name)}
              value={name}
              id={name}
              name={name}
              onChange={onChange}
            />
          </div>
          <div className={styles.r24SelectCarModelImage}>
              {icon === 'parking' ?
                  <img width="19" height="23" style={style}
                   src={rootUrl + "/assets/icons/new/search/icon-model-select-" + icon + ".png"}
                   alt="icon-model-select-" loading="lazy"/>
                  :<img width="40" height="23" style={style}
                        src={rootUrl + "/assets/icons/new/search/icon-model-select-" + icon + ".svg"}
                        alt="icon-model-select-" loading="lazy"/>}

          </div>
            <div className={styles.r24SelectCarModel}>
                {translateService.translate('vehicleSearch.' + name)}
            </div>
        </label>
    </>
  }

    const RadioButtons = ({name, options, selected, onChange}: IProps) => {
        return <div className={cx(styles.r24FullWidth, styles.r24Padding5, styles.advancedSearchRow)}>
            {options && options.map((option, index) => {
                return <label key={name + index} htmlFor={name + index} >
                    <input type="radio" name={name} readOnly checked={selected === option} value={option} id={option} onChange={onChange} />
                    <label htmlFor={option}>{translateService.translate('vehicleSearch.'+option.split('_')[0])}</label>
                </label>
            })}
        </div>
    };

  return <div className={styles.searchFilter}>
      <div className={cx(styles.searchFilter, styles.noBorderAround, styles.r24FullWidth, styles.r24BottomMargin10)} id="services">
        <div className={cx(styles.r24FullWidthFlexCenter, styles.r24BottomMargin10)}>
          <span className={styles.r24filterResults}>{translateService.translate('vehicleSearch.filterResults')}</span>
        </div>
          { selectedModelId ?
              <div style={{display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center"}}>
                  <span className={styles.r24filterResults}> {translateService.translate('vehicleSearch.showingModelBasedResults')} </span>
                  <div className={styles.r24HalfWidthFlexEnd}>
                      <button onClick={() => handleRemoveModelSearch()}
                              className="btn btn-info btn-outline-info w-100 font-weight-bold text-uppercase">
                         {translateService.translate('vehicleSearch.removedModelFilterBtn')}</button>
                  </div>
                  <br/>
              </div>
              :
              <div className={styles.r24FullWidthFlexEnd}>
                  <CarTypeCheckbox name={"compact"} style={{width: '34px', height: '18px',display: 'inline-block', verticalAlign: 'middle' }} icon={"medium"} onChange={handleInputChange} />
                  <CarTypeCheckbox name={"stw"} style={{width: '42px', height: '18px',display: 'inline-block', verticalAlign: 'middle' }} icon={"large"} onChange={handleInputChange}/>
                  <CarTypeCheckbox name={"suv"} style={{width: '39px', height: '22px',display: 'inline-block', verticalAlign: 'middle' }} icon={"suv"} onChange={handleInputChange} />
                  <CarTypeCheckbox name={"minibus"} style={{width: '40px', height: '23px',display: 'inline-block', verticalAlign: 'middle' }} icon={"minibus"} onChange={handleInputChange}/>
                  <CarTypeCheckbox name={"van"} style={{width: '39px', height: '23px',display: 'inline-block', verticalAlign: 'middle' }} icon={"van"} onChange={handleInputChange}/>
                  <CarTypeCheckbox name={'parkinghall'} style={{width: '19px', height: '23px',display: 'inline-block', verticalAlign: 'middle' }} icon={"parking"} onChange={handleInputChange}/>
                  <CarTypeCheckbox name={"eco"} style={{width: '19px', height: '23px',display: 'inline-block', verticalAlign: 'middle' }} icon={"eco"} onChange={handleInputChange} />
              </div>
          }

        <div className={styles.r24FullWidthFlexEnd}>
          <div className={cx(styles.r24ChildFlex1, styles.r24FlexEnd)}>
            <button className={styles.advancedSearchButton} onClick={()=>{setFiltersVisible(v=>!v);
                if(!filtersVisible) {sendGaEvent('searchOptions', 'showAdvancedOptions', '', 0)}}}>
              <strong></strong>{filtersVisible ? translateService.translate('vehicleSearch.close') :
                      translateService.translate('vehicleSearch.moreFilters')}
              &nbsp;
              <FontAwesomeIcon icon={filtersVisible ? faChevronUp : faChevronDown} />
            </button>
          </div>
        </div>
        
        { filtersVisible && 
          <div className={cx(styles.r24FullWidth, styles.r24TopPadding1)}>
            <div className={styles.collapsibleBody}>
              <div className={cx(styles.r24FullWidthFlexNormal, styles.r24Padding5)}>
                <div className={cx( styles.r24Padding5)}>
                  <span className={styles.advancedSearchText}>{translateService.translate('vehicleSearch.fuelType')}</span>
                </div>
                <div className={cx(styles.r24FullWidth, styles.r24Padding5, styles.advancedSearchRow)}>
                    <RadioButtons options={fuelOptions} name={'fuelType'} selected={selectedFuelType} onChange={handleFuelTypeChange} />
                </div>
              </div>
              <div className={cx(styles.r24FullWidth, styles.lightGrayline, styles.r24TopBottomMargin5)}></div>
              <div className={cx(styles.r24FullWidthFlexNormal, styles.r24Padding5)}>
                <div className={cx( styles.r24Padding5)}>
                  <span className={styles.advancedSearchText}>{translateService.translate('vehicleSearch.crossBorderTravel')}</span>
                </div>
                <div className={cx(styles.r24FullWidth, styles.r24Padding5, styles.advancedSearchRow)}>
                    <RadioButtons
                        name={'countryAreaSelection'}
                        options={countryOptions}
                        selected={selectedCountry}
                        onChange={handleCountryChange}
                    />
                </div>
              </div>
              <div className={cx(styles.r24FullWidth, styles.lightGrayline, styles.r24TopBottomMargin5)}></div>
              <div className={cx(styles.r24FullWidthFlexNormal, styles.r24Padding5)}>
                <div className={cx(styles.r24Padding5)}>
                  <span className={styles.advancedSearchText}>{translateService.translate('vehicleSearch.transmission')}</span>
                </div>
                <div className={cx(styles.r24FullWidth, styles.r24Padding5, styles.advancedSearchRow)} >
                   <RadioButtons name={'otherVehicleSelection'} options={vehicleTypeOptions} selected={selectTransmission} onChange={handleTransmissionChange} />
                </div>
              </div>
              <div className={cx(styles.r24FullWidth, styles.lightGrayline, styles.r24TopBottomMargin5)}></div>
              <div className={cx(styles.r24FullWidthFlexNormal, styles.r24Padding5)}>
                <div className={cx(styles.r24Padding5)}>
                  <span className={styles.advancedSearchText}>{translateService.translate('vehicleSearch.equipment')}</span>
                </div>
                <div className={'w-full d-flex flex-row'}>
                    <CheckBoxTyreButton className={'px-3'} name={'towingHitch'} onChange={handleTyreChange} />
                    <CheckBoxTyreButton className={'px-3'} name={'studdedTyres'} onChange={handleTyreChange} />
                    <CheckBoxTyreButton className={'px-3'} name={'allSeasonTyres'} onChange={handleTyreChange} />
                    <CheckBoxTyreButton className={'px-3'} name={'summerTyres'} onChange={handleTyreChange} />
                    <CheckBoxTyreButton className={'px-3'} name={'parkingPermit'} onChange={handleTyreChange} />
                </div>
              </div>
              <div className={cx(styles.r24FullWidth, styles.lightGrayline, styles.r24TopBottomMargin5)}></div>
              <Coupon changeSearchParameters={changeSearchParameters}/>
            </div>
          </div>
        }
      </div>
  </div>

}